import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import moment from "moment";
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { SuccessToast } from "../../utils/utils";
import ConfirmDialog from "../../components/ConfirmDialog";
import DeleteButton from "../../components/DeleteButton";

export default function AdminNewsPage() {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const [news, setNews] = useState([]);
    
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
  
    const handleChangePage = (event, newPage) => {
      setPage(newPage);

      Backend.get(`news?page=${newPage}`)
      .then(res => {
          setTotalCount(res.totalCount);
          setNews(res.data);
          setIsLoading(false);
      });
    };

    useEffect(() => {
        Backend.get(`news?page=${page}`)
            .then(res => {
                setTotalCount(res.totalCount);
                setNews(res.data);
                setIsLoading(false);
            });
    }, []);

    const goToNewsPage = (id) => {
        navigate(`/dashboard/news/${id}`);
    }

    const goToNewsEditPage = (e, id) => {
      e.preventDefault();
      e.stopPropagation();

      navigate(`/dashboard/edit-news/${id}`);
    }

    const deleteNews = (e, id) => {
      e.preventDefault();
      e.stopPropagation();

      Backend.delete(`news/${id}`)
        .then(res => {
          SuccessToast("News deleted");
          setTimeout(() => window.location.href = '/dashboard/news', 1000);
        })
    }

    return <div>
    <Link to="/dashboard/add-news"><Button variant="contained" >Add News</Button></Link>
    <br />
    <br />
    {isLoading ? <div className="mx-auto mt-4 w-fit"><Loader /></div> : <>
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow className="bg-slate-950">
            <TableCell width="5%">Id</TableCell>
            <TableCell >Title</TableCell>
            <TableCell width="15%">Upload Date</TableCell>
            <TableCell width="3%"></TableCell>
            <TableCell width="3%"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {news.reverse().map((row) => (
            <TableRow key={row.id} onClick={() => goToNewsPage(row.id)}>
              <TableCell>{row.id}</TableCell>
              <TableCell >{row.title}</TableCell>
              <TableCell >{moment(row.uploadDate).local().format("YYYY-MM-DD")}</TableCell>
              <TableCell><EditIcon className="cursor-pointer" onClick={(e) => goToNewsEditPage(e, row.id)}/></TableCell>
              {/* <TableCell><DeleteIcon className="cursor-pointer" onClick={(e) => deleteNews(e, row.id)}/></TableCell> */}
              <TableCell><DeleteButton onClick={(e) => deleteNews(e, row.id)}/></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    <TablePagination
          rowsPerPageOptions={10}
          component="div"
          count={totalCount}
          rowsPerPage={10}
          page={page}
          onPageChange={handleChangePage}
        />
      </>}
    </div>
}